// extracted by mini-css-extract-plugin
export default {"p_tye":"_95549701d9","slcted":"ff3702b4a4","slc_color":"efd2e2193a","item_p":"f6e85f7fe7","r0":"b4063f56f7"};